export const TrainingControlsCommand = {
  RTL: 'rtl',
  FC_LOSS: 'fc_loss',
  SAFE_UP: 'safe_up',
  VEHICLE_DISCONNECTION: 'vehicle_disconnection',
  LAND: 'land',
  FTS: 'fts',
  DAA: 'daa',
  REMOTE_ID_FAILURE: 'remote_id_failure',
  RESTART_VEHICLE: 'restart_vehicle'
} as const;

export type TrainingControlsCommand = (typeof TrainingControlsCommand)[keyof typeof TrainingControlsCommand];
